import React, { useContext, useEffect, useState } from "react";
import { HTTPResponse, SideMenuItems, ToastMessages, ToastMessageType, Values } from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import { CommonError_Msgs } from "../../Helpers/HelperText";
import { AppContext } from "../../Contexts/AppContextProvider";
import {  applySidebarState,  GetLocalStorageData, GetLoggedInUserID, toggleSidebar } from "../../Helpers/Utilities";
import { NonMDETreatmentService } from "../../WebApiServices/NonMDETreatment.service";
import ErrorField from "../../Components/ErrorField";

const NonMDETreatment = () => {
  const navigatePaths = {
    prevPage: "",
    currPage: "/NonMDETreatment",
    nextPage: "/RenalLabAssessment",
  };

  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    setisSideMenuActive,
  } = useContext(AppContext);

    //ST: 3/3/2025
    // Create a state for the treatment list that will be mapped into the table.
  let patientId = GetLocalStorageData("patientId") ?? 0;
  let dates = GetLocalStorageData("ClinicalCharacteristicsDates") || {};

  // If value is false then don't show column
  let dontShowCol1 = dates?.pretransplant_start_end_criteria === false;
  let dontShowCol2 = dates?.indexdate_threemonth_criteria === false;
  let dontShowCol3 = dates?.post_stabilization_twelvemonth_criteria === false;
  let dontShowCol4 = dates?.twelvemonth_twentyfourmonth_criteria === false;
    
  const userId = GetLoggedInUserID();
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);
  const [treatmentList, setTreatmentList] = useState([]);

  const InitialHardErrList = {
    treatmentEmpty: false,
    preTransplantEmpty: false,
    threeMonthEmpty: false,
    postStabilizationEmpty: false,
    twelveMonthEmpty: false,
  };
  const [hardErrList, setHardErrList] = useState(InitialHardErrList);
 const [patientLocked, setpatientLocked] = useState(false);
  useEffect(() => {
    async function FetchData() {
      if (!isNaN(patientId) && Number(patientId) !== 0) {
        ToggleLoader(true);
        await LoadData();
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

    // Load function: calls the service and sets the treatment list.
  const LoadData = async () => {
    try {
      const response = await NonMDETreatmentService.LoadData(patientId, userId);
      if (response?.status === HTTPResponse.OK) {
        setpatientLocked(response.data?.patientLocked);

        let list = (response.data?.nonMDETreatmentList || []).sort(
          (a, b) => a.nonMDETreatmentId - b.nonMDETreatmentId
        );
    
        const columns = [
          "preTransplantStartEnd",
          "threeMonthStabilization",
          "postStabilization",
          "twelveMonthPostStabilization",
        ];
    
        columns.forEach((col) => {
          const hasCheckboxSelected = list.some(
            (item) => !item.radioType && item[col]
          );
          if (hasCheckboxSelected) {
            list = list.map((item) => {
              if (item.radioType) {
                return { ...item, [col]: false };
              }
              return item;
            });
          }
        });
    
        setTreatmentList(list);
      } else if (response?.status === HTTPResponse.Unauthorized) {
        HandleSessionTimeout();
      } else {
        throw response.error;
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  };
    
  // Mapping between field names and error keys.
  const fieldErrorMap = {
    preTransplantStartEnd: 'preTransplantEmpty',
    threeMonthStabilization: 'threeMonthEmpty',
    postStabilization: 'postStabilizationEmpty',
    twelveMonthPostStabilization: 'twelveMonthEmpty'
  };

  const handleFieldChange = (e, index, fieldName) => {
    const { checked } = e.target;
    setHardErrList((prev) => ({
      ...prev,
      [fieldErrorMap[fieldName]]: false
    }));
  
    setTreatmentList((prevList) => {
      const newList = [...prevList];
      // Update the clicked row with the new checkbox value
      newList[index] = { ...newList[index], [fieldName]: checked };
  
      // If this is a child row and it's being checked, update the immediate parent above
      if (!newList[index].parentheader && checked) {
        for (let i = index - 1; i >= 0; i--) {
          if (newList[i].parentheader) {
            newList[i] = { ...newList[i], [fieldName]: true };
            break;
          }
        }
      }
  
      // If this is a parent row and it's being unchecked, update all its child rows below to false
      if (newList[index].parentheader && !checked) {
        for (let i = index + 1; i < newList.length; i++) {
          if (newList[i].parentheader) {
            break;
          }
          newList[i] = { ...newList[i], [fieldName]: false };
        }
      }
  
      // Reset all radio-type rows for this column (clear any radio selections)
      newList.forEach((item, idx) => {
        if (item.radioType) {
          newList[idx] = { ...newList[idx], [fieldName]: false };
        }
      });
  
      return newList;
    });
  };
  
  

  const handleRadioChange = (e, index) => {
    const selectedValue = Number(e.target.value);
    let fieldName;
    if (selectedValue === Values.value1) fieldName = 'preTransplantStartEnd';
    else if (selectedValue === Values.value2) fieldName = 'threeMonthStabilization';
    else if (selectedValue === Values.value3) fieldName = 'postStabilization';
    else if (selectedValue === Values.value4) fieldName = 'twelveMonthPostStabilization';
      
    setHardErrList((prev) => ({
      ...prev,
      [fieldErrorMap[fieldName]]: false
    }));

    setTreatmentList((prevList) =>
      prevList.map((item, idx) => ({
        ...item,
        [fieldName]: idx === index
      }))
    );
  };

  // UPDATED: Modified Validate to bypass non-applicable columns.
  const Validate = () => {
    if (!treatmentList || treatmentList.length === 0) {
      setHardErrList((prev) => ({
        ...prev,
        preTransplantEmpty: dontShowCol1 ? false : true,
        threeMonthEmpty: dontShowCol2 ? false : true,
        postStabilizationEmpty: dontShowCol3 ? false : true,
        twelveMonthEmpty: dontShowCol4 ? false : true,
      }));
      return false;
    }
    
    const preTransplantValid = dontShowCol1 || treatmentList.some(
      (treatment) => treatment.preTransplantStartEnd
    );
    const threeMonthValid = dontShowCol2 || treatmentList.some(
      (treatment) => treatment.threeMonthStabilization
    );
    const postStabilizationValid = dontShowCol3 || treatmentList.some(
      (treatment) => treatment.postStabilization
    );
    const twelveMonthValid = dontShowCol4 || treatmentList.some(
      (treatment) => treatment.twelveMonthPostStabilization
    );
    
    setHardErrList((prev) => ({
      ...prev,
      // preTransplantEmpty: dontShowCol1 ? false : !preTransplantValid,
      // threeMonthEmpty: dontShowCol2 ? false : !threeMonthValid,
      // postStabilizationEmpty: dontShowCol3 ? false : !postStabilizationValid,
      // twelveMonthEmpty: dontShowCol4 ? false : !twelveMonthValid,

      //NN: 23/4/2025 SonarQube fix Ternary operator should not be used instead of simpler alternatives javascript:S6644
      preTransplantEmpty: !dontShowCol1 && !preTransplantValid,
      threeMonthEmpty: !dontShowCol2 && !threeMonthValid,
      postStabilizationEmpty: !dontShowCol3 && !postStabilizationValid,
      twelveMonthEmpty: !dontShowCol4 && !twelveMonthValid,
    }));
    
    const isValid = preTransplantValid && threeMonthValid && postStabilizationValid && twelveMonthValid;
    return isValid;
  };
  
  const SavePage = async (validate) => { 
      try {
          if (!patientLocked) {
              // Reset errors (if you're using similar error states as in your reference)
              setHardErrList(InitialHardErrList);
              let isValid = validate ? Validate() : true;
              if (!isValid) {
                  setShowTopErrMsg(true);
                  return false;
              }
              setShowTopErrMsg(false);

              // Build the payload for saving. Each treatment item is mapped into the payload.
              const payload = {
                  IsValidated: validate,
                  PatientId: patientId,
                  UserId: userId,
                  NonMDETreatmentList: treatmentList.map((treatment) => ({
                      NonMDETreatmentId: treatment.nonMDETreatmentId, // treatment id from your names table
                      NonMDECharacteristicsId: treatment.NonMDECharacteristicsId,
                      PreTransplantStartEnd: treatment.preTransplantStartEnd,
                      ThreeMonthStabilization: treatment.threeMonthStabilization,
                      PostStabilization: treatment.postStabilization,
                      TwelveMonthPostStabilization: treatment.twelveMonthPostStabilization,
                  })),
              };

              ToggleLoader(true);
              const response = await NonMDETreatmentService.SaveData(payload);
              ToggleLoader(false);
              if (response.status !== HTTPResponse.OK) {
                  if (response?.status === HTTPResponse.Unauthorized) {
                      HandleSessionTimeout();
                  } else {
                      throw response.error;
                  }
              } else {
                  ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
                  await LoadData(); // Reload data if needed after saving
              }
          }
      return true;
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);


  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>

      <section className="main-survey-section main-survey-button">
        <div>
          <SideBarMenu activePageId={SideMenuItems.NonMdeTreatment} />
          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() => toggleSidebar(isSideMenuActive, setisSideMenuActive)}
            >
              <i id="arrowNavigation" className="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
          </>
          <div className="col-pad-left eligibiltylocked" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header">
                <h4>NON-MDE TREATMENT CHARACTERISTICS</h4>
              </div>

              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField show={showTopErrMsg} message={CommonError_Msgs.Hard_Empty} />
                </div>
              )}

              {/* <summary>
              date: 23-12-2024
              Name: ST
              description: NonMDETreatment Design
              <summary> */}
              <div className="survey-question-section" >
                <div className="survey-question-content survey-content-box">
                  <div className="question-answer grid-overflow">
                    <div className="block-border white-bg" style={{marginBlock: "20px 0"}}>
                      <div>
                        <div className="custom-table grid-overflow">
                          <div className="question question-weight">
                            <span>Q30.</span>
                            <span className="quest-text-pad">
                              Please report which, if any, of the following treatments were reported being used <u>outside of MDEs only</u> within the periods defined below. <i>Select all that apply.</i>
                              <br />
                              <b>Please note:</b> Records indicating that any of the below treatments were used during an MDE (previously reported in <span className="indigo-text">Q28.1</span>) should not be considered when answering below. Only if a treatment is used outside of an MDE should it be considered.
                            </span>
                          </div>
                          <br></br>

                          <div className="custom-table grid-overflow">

                              {/* new */}
                              <div className="frozen-col-view">
                                                <div className="floating-border-left"></div>
                                                <div className="floating-border-right"></div>
                                                <div className="frozen-col-wrapper">
                                                  <table className="custom-child-tables custom-head-border custom-table-sec"  style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}>
                                                    <thead className="custom-parent-cell-border">
                                                      <tr className="custom-parent-cell-border">
                                                        <th className="modal-popup-table-header-cell custom-head-size sticky-col first-col">
                                                          <div className="position-rel">
                                                            <div className="floating-bottom-border floating-head-border"></div>
                                                            Target periods
                                                          </div>
                                                        </th>
                                                        <th className="modal-popup-table-header-cell custom-head-size">
                                                          From <span className="indigo-text">{dates?.oneYr_pretransplant_start ?? "[1-year pre-transplant start]"}</span> to <span className="indigo-text">{dates?.oneYr_pretransplant_end ?? "[1-year pre-transplant end]"}</span>
                                                        </th>
                                                        <th className="modal-popup-table-header-cell custom-head-size">
                                                          From <span className="indigo-text">{dates?.indexDt ?? "[index date]"}</span> to <span className="indigo-text">{dates?.three_month_stabilization ?? "[3-month stabilization date]"}</span>
                                                        </th>
                                                        <th className="modal-popup-table-header-cell custom-head-size">
                                                          From <span className="indigo-text">{dates?.post_stabilization_start ?? "[Post-stabilization start date]"}</span> to <span className="indigo-text">{dates?.twelve_month_post_stabilization ?? "[12-month post-stabilization date]"}</span>
                                                        </th>
                                                        <th className="modal-popup-table-header-cell custom-head-size">
                                                            From <span className="indigo-text">{dates?.twelve_month_post_stabilization_plusOneday ?? "[12-month post-stabilization date + 1 day]"}</span> 
                                                            {" "}to <span className="indigo-text">{dates?.twenty_four_months_post_stabilization ?? "[24-month post-stabilization date]"}</span>
                                                        </th>
                                                      </tr>

                                                    </thead>
                                                    <tbody>
                                    {treatmentList.map((treatment, index) => (
                                      <tr key={treatment.nonMDETreatmentId}>
                                        <td className="modal-popup-table-cell sticky-col first-col border-none">
                                          <div className="custom-date-field-padding">
                                            <div className="position-rel">
                                              {index !== 0 && <div className="floating-bottom-border"></div>}
                                              <label className={!treatment.parentheader ? "indent-treatment-name" : ""}>
                                                {treatment.treatmentName}
                                              </label>
                                            </div>
                                          </div>
                                        </td>
                                        {treatment.radioType ? (
                                          <>
                                            {dontShowCol1 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="radio" name={`radio_col1`} value="1" checked={treatment.preTransplantStartEnd} onChange={(e) => handleRadioChange(e, index)} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol2 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="radio" name={`radio_col2`} value="2" checked={treatment.threeMonthStabilization} onChange={(e) => handleRadioChange(e, index)} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol3 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="radio" name={`radio_col3`} value="3" checked={treatment.postStabilization} onChange={(e) => handleRadioChange(e, index)} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol4 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="radio" name={`radio_col4`} value="4" checked={treatment.twelveMonthPostStabilization} onChange={(e) => handleRadioChange(e, index)} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {dontShowCol1 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="checkbox" checked={treatment.preTransplantStartEnd || false} onChange={(e) => handleFieldChange(e, index, "preTransplantStartEnd")} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol2 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="checkbox" checked={treatment.threeMonthStabilization || false} onChange={(e) => handleFieldChange(e, index, "threeMonthStabilization")} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol3 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="checkbox" checked={treatment.postStabilization || false} onChange={(e) => handleFieldChange(e, index, "postStabilization")} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol4 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="checkbox" checked={treatment.twelveMonthPostStabilization || false} onChange={(e) => handleFieldChange(e, index, "twelveMonthPostStabilization")} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        )}
                                      </tr>
                                    ))}
                                    {/* UPDATED: Conditionally render error row only when at least one error exists */}
                                    {( (!dontShowCol1 && hardErrList.preTransplantEmpty) ||
                                      (!dontShowCol2 && hardErrList.threeMonthEmpty) ||
                                      (!dontShowCol3 && hardErrList.postStabilizationEmpty) ||
                                      (!dontShowCol4 && hardErrList.twelveMonthEmpty)
                                    ) && (
                                      <tr>
                                        <td className="sticky-col first-col">
                                        <div className="position-rel">
                                        <div className="floating-bottom-border"></div>
                                        <div style={{height:"23px"}}></div>
                                        </div>
                                        </td>
                                        <td>
                                          {!dontShowCol1 && hardErrList.preTransplantEmpty && (
                                            <ErrorField
                                            show={showTopErrMsg}
                                            message={CommonError_Msgs.Msg1}
                                          />
                                          )}
                                        </td>
                                        <td>
                                          {!dontShowCol2 && hardErrList.threeMonthEmpty && (
                                            <ErrorField
                                            show={showTopErrMsg}
                                            message={CommonError_Msgs.Msg1}
                                          />
                                          )}
                                        </td>
                                        <td>
                                          {!dontShowCol3 && hardErrList.postStabilizationEmpty && (
                                            <ErrorField
                                            show={showTopErrMsg}
                                            message={CommonError_Msgs.Msg1}
                                          />
                                          )}
                                        </td>
                                        <td>
                                          {!dontShowCol4 && hardErrList.twelveMonthEmpty && (
                                            <ErrorField
                                            show={showTopErrMsg}
                                            message={CommonError_Msgs.Msg1}
                                          />
                                          )}
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                                  </table>
                                                </div>
                                              </div>
                              {/* new */}



                                {/* <table className="custom-child-table custom-head-border custom-th-width custom-table-sec" style={{ width: "100%" }}>
                                  <thead className="custom-parent-cell-border">
                                    <tr className="custom-parent-cell-border">
                                      <th className="modal-popup-table-header-cell">Target periods</th>
                                      <th className="modal-popup-table-header-cell">
                                        From <span className="indigo-text">{dates?.oneYr_pretransplant_start ?? "[1-year pre-transplant start]"}</span> to <span className="indigo-text">{dates?.oneYr_pretransplant_end ?? "[1-year pre-transplant end]"}</span>
                                      </th>
                                      <th className="modal-popup-table-header-cell">
                                        From <span className="indigo-text">{dates?.indexDt ?? "[index date]"}</span> to <span className="indigo-text">{dates?.three_month_stabilization ?? "[3-month stabilization date]"}</span>
                                      </th>
                                      <th className="modal-popup-table-header-cell">
                                        From <span className="indigo-text">{dates?.post_stabilization_start ?? "[Post-stabilization start date]"}</span> to <span className="indigo-text">{dates?.twelve_month_post_stabilization ?? "[12-month post-stabilization date]"}</span>
                                      </th>
                                      <th className="modal-popup-table-header-cell">
                                        From <span className="indigo-text">{dates?.twelve_month_post_stabilization_plusOneday ?? "[12-month post-stabilization date + 1 day]"}</span> to <span className="indigo-text">{dates?.twenty_four_months_post_stabilization ?? "[24-month post-stabilization date]"}</span>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {treatmentList.map((treatment, index) => (
                                      <tr key={index}>
                                        <td className="modal-popup-table-cell">
                                          <div className="custom-date-field-padding">
                                          <label className={`option-fbox ${treatment.parentheader ? "" : "indent-treatment-name"}`}>
                                            {treatment.treatmentName}
                                          </label>
                                          </div>
                                        </td>
                                        {treatment.radioType ? (
                                          <>
                                            {dontShowCol1 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="radio" name={`radio_col1`} value="1" checked={treatment.preTransplantStartEnd} onChange={(e) => handleRadioChange(e, index)} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol2 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="radio" name={`radio_col2`} value="2" checked={treatment.threeMonthStabilization} onChange={(e) => handleRadioChange(e, index)} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol3 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="radio" name={`radio_col3`} value="3" checked={treatment.postStabilization} onChange={(e) => handleRadioChange(e, index)} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol4 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="radio" name={`radio_col4`} value="4" checked={treatment.twelveMonthPostStabilization} onChange={(e) => handleRadioChange(e, index)} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {dontShowCol1 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="checkbox" checked={treatment.preTransplantStartEnd || false} onChange={(e) => handleFieldChange(e, index, "preTransplantStartEnd")} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol2 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="checkbox" checked={treatment.threeMonthStabilization || false} onChange={(e) => handleFieldChange(e, index, "threeMonthStabilization")} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol3 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="checkbox" checked={treatment.postStabilization || false} onChange={(e) => handleFieldChange(e, index, "postStabilization")} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol4 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="checkbox" checked={treatment.twelveMonthPostStabilization || false} onChange={(e) => handleFieldChange(e, index, "twelveMonthPostStabilization")} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        )}
                                      </tr>
                                    ))}
                                    {( (!dontShowCol1 && hardErrList.preTransplantEmpty) ||
                                      (!dontShowCol2 && hardErrList.threeMonthEmpty) ||
                                      (!dontShowCol3 && hardErrList.postStabilizationEmpty) ||
                                      (!dontShowCol4 && hardErrList.twelveMonthEmpty)
                                    ) && (
                                      <tr>
                                        <td></td>
                                        <td>
                                          {!dontShowCol1 && hardErrList.preTransplantEmpty && (
                                            <ErrorField
                                            show={showTopErrMsg}
                                            message={CommonError_Msgs.Msg1}
                                          />
                                          )}
                                        </td>
                                        <td>
                                          {!dontShowCol2 && hardErrList.threeMonthEmpty && (
                                            <ErrorField
                                            show={showTopErrMsg}
                                            message={CommonError_Msgs.Msg1}
                                          />
                                          )}
                                        </td>
                                        <td>
                                          {!dontShowCol3 && hardErrList.postStabilizationEmpty && (
                                            <ErrorField
                                            show={showTopErrMsg}
                                            message={CommonError_Msgs.Msg1}
                                          />
                                          )}
                                        </td>
                                        <td>
                                          {!dontShowCol4 && hardErrList.twelveMonthEmpty && (
                                            <ErrorField
                                            show={showTopErrMsg}
                                            message={CommonError_Msgs.Msg1}
                                          />
                                          )}
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>


                                </table> */}
                              
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    
                    {/* <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                      <tr>
                        <td className="">
                          <table cellPadding="0" cellSpacing="0" width="100%" border="1" className="borderTable">
                            <tr>
                              <td className="containertd">
                                <div className="question question-weight">
                                  <span>Q30.</span>
                                  <span className="quest-text-pad">
                                    Please report which, if any, of the following treatments were reported being used <u>outside of MDEs only</u> within the periods defined below. <i>Select all that apply.</i>
                                    <br />
                                    <b>Please note:</b> Records indicating that any of the below treatments were used during an MDE (previously reported in <span className="indigo-text">Q28.1</span>) should not be considered when answering below. Only if a treatment is used outside of an MDE should it be considered.
                                  </span>
                                </div>
                              </td>
                            </tr>
                            <tr className="custom-parent-cell-border">
                              <td className="custom-parent-cell-border">
                                <table className="custom-child-table custom-child-table-column custom-th-width">
                                  <thead className="custom-parent-cell-border">
                                    <tr className="custom-parent-cell-border">
                                      <th className="modal-popup-table-header-cell">Target periods</th>
                                      <th className="modal-popup-table-header-cell">
                                        From <span className="indigo-text">{dates?.oneYr_pretransplant_start ?? "[1-year pre-transplant start]"}</span> to <span className="indigo-text">{dates?.oneYr_pretransplant_end ?? "[1-year pre-transplant end]"}</span>
                                      </th>
                                      <th className="modal-popup-table-header-cell">
                                        From <span className="indigo-text">{dates?.indexDt ?? "[index date]"}</span> to <span className="indigo-text">{dates?.three_month_stabilization ?? "[3-month stabilization date]"}</span>
                                      </th>
                                      <th className="modal-popup-table-header-cell">
                                        From <span className="indigo-text">{dates?.post_stabilization_start ?? "[Post-stabilization start date]"}</span> to <span className="indigo-text">{dates?.twelve_month_post_stabilization ?? "[12-month post-stabilization date]"}</span>
                                      </th>
                                      <th className="modal-popup-table-header-cell">
                                        From <span className="indigo-text">{dates?.twelve_month_post_stabilization_plusOneday ?? "[12-month post-stabilization date + 1 day]"}</span> to <span className="indigo-text">{dates?.twenty_four_months_post_stabilization ?? "[24-month post-stabilization date]"}</span>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {treatmentList.map((treatment, index) => (
                                      <tr key={index}>
                                        <td className="modal-popup-table-cell">
                                          <div className="custom-date-field-padding">
                                          <label className={`option-fbox ${treatment.parentheader ? "" : "indent-treatment-name"}`}>
                                            {treatment.treatmentName}
                                          </label>
                                          </div>
                                        </td>
                                        {treatment.radioType ? (
                                          <>
                                            {dontShowCol1 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="radio" name={`radio_col1`} value="1" checked={treatment.preTransplantStartEnd} onChange={(e) => handleRadioChange(e, index)} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol2 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="radio" name={`radio_col2`} value="2" checked={treatment.threeMonthStabilization} onChange={(e) => handleRadioChange(e, index)} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol3 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="radio" name={`radio_col3`} value="3" checked={treatment.postStabilization} onChange={(e) => handleRadioChange(e, index)} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol4 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="radio" name={`radio_col4`} value="4" checked={treatment.twelveMonthPostStabilization} onChange={(e) => handleRadioChange(e, index)} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {dontShowCol1 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="checkbox" checked={treatment.preTransplantStartEnd || false} onChange={(e) => handleFieldChange(e, index, "preTransplantStartEnd")} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol2 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="checkbox" checked={treatment.threeMonthStabilization || false} onChange={(e) => handleFieldChange(e, index, "threeMonthStabilization")} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol3 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="checkbox" checked={treatment.postStabilization || false} onChange={(e) => handleFieldChange(e, index, "postStabilization")} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                            {dontShowCol4 ? (
                                              index === 0 && (
                                                <td rowSpan={treatmentList.length} className="modal-popup-table-cell parent-custom-bottom-border-disabled">
                                                  <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div>
                                                </td>
                                              )
                                            ) : (
                                              <td className="modal-popup-table-cell">
                                                <div className="custom-date-field-padding">
                                                  <label className="option-fbox fbox-justified">
                                                    <input type="checkbox" checked={treatment.twelveMonthPostStabilization || false} onChange={(e) => handleFieldChange(e, index, "twelveMonthPostStabilization")} />
                                                  </label>
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        )}
                                      </tr>
                                    ))}
                                   
                                    {( (!dontShowCol1 && hardErrList.preTransplantEmpty) ||
                                      (!dontShowCol2 && hardErrList.threeMonthEmpty) ||
                                      (!dontShowCol3 && hardErrList.postStabilizationEmpty) ||
                                      (!dontShowCol4 && hardErrList.twelveMonthEmpty)
                                    ) && (
                                      <tr>
                                        <td></td>
                                        <td>
                                          {!dontShowCol1 && hardErrList.preTransplantEmpty && (
                                            <ErrorField
                                            show={showTopErrMsg}
                                            message={CommonError_Msgs.Msg1}
                                          />
                                          )}
                                        </td>
                                        <td>
                                          {!dontShowCol2 && hardErrList.threeMonthEmpty && (
                                            <ErrorField
                                            show={showTopErrMsg}
                                            message={CommonError_Msgs.Msg1}
                                          />
                                          )}
                                        </td>
                                        <td>
                                          {!dontShowCol3 && hardErrList.postStabilizationEmpty && (
                                            <ErrorField
                                            show={showTopErrMsg}
                                            message={CommonError_Msgs.Msg1}
                                          />
                                          )}
                                        </td>
                                        <td>
                                          {!dontShowCol4 && hardErrList.twelveMonthEmpty && (
                                            <ErrorField
                                            show={showTopErrMsg}
                                            message={CommonError_Msgs.Msg1}
                                          />
                                          )}
                                        </td>
                                      </tr>
                                    )}
                                                                  </tbody>

                                </table>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table> */}


                    <br />
                    <br />
                  </div>
                </div>
              </div>

              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NonMDETreatment;
